import { EditorProps } from 'react-data-grid'

import { memo } from 'react'

import { DgtPdOrderOperationLog } from '../models'
import { SummaryLogRow } from '../constants/Column'
import { SHIFT } from '../constants/EnumType'

export default memo(function SelectShiftEditor({ props } : {
  props: EditorProps<DgtPdOrderOperationLog, SummaryLogRow>
}) {
  const { row, onRowChange } = props
  return <div className='flex items-center justify-center w-full h-full'>
    <select title='select'
      value={row?.shift || '-'}
      className='p-1 border border-gray-400 rounded-md'
      onChange={(e) => {
        let updatedRow = { ...row, shift: e.currentTarget.value } as DgtPdOrderOperationLog
        onRowChange(updatedRow, true)
      }}
      onKeyDown={(e) => e.stopPropagation()}
    >
      {Object.keys(SHIFT).map(shf => {
        const shift = SHIFT[shf as keyof typeof SHIFT]
        return <option key={shf} value={shift.value}>{shift.display}</option>
      })}
    </select>
  </div>
})